class StoreDeviceMarkerType {
  constructor (
    id = undefined,
    name
  ) {
    this.id = id
    this.name = name
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name
  }) {
    return new StoreDeviceMarkerType(
      id,
      name
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name
    }
  }

  static FromJSON ({
    id,
    name
  }) {
    return new StoreDeviceMarkerType(
      id,
      name
    )
  }
}

StoreDeviceMarkerType.MARKER_TYPE_IDS = {
  CIRCLE: 1,
  TRIANGLE: 2,
  SQUARE: 3
}

export default StoreDeviceMarkerType
